export {default} from './WalletSettings';
